import { Box } from '@mui/system';

import _ from 'lodash';

import { GuardianRulesTable } from './GuardianRulesTable';

interface IProps {
  analysisId: string;
  data: object;
  customRules?: object;
  refresh?: () => void;
  filterSection?: 'overview' | 'permission' | 'behaviors' | 'malicious' | '';
}

export const FiltersAndTable = ({ analysisId, data, customRules, refresh, filterSection }: IProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', minHeight: '100vh' }}>
      <Box
        sx={{
          overflowY: 'auto',
        }}
      >
        <GuardianRulesTable data={data} analysisId={analysisId} customRules={customRules} refresh={refresh} filterSection={filterSection} />
      </Box>
    </Box>
  );
};
